





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({
    name: "modalPopup",
    components: {}
})
export default class modalPopup extends Vue {
    @Prop({ type: Object }) bus!: any;
    @Prop({ type: String }) namespace!: string;
    @Prop({ type: String }) sizeClass!: string;
    @Prop({ type: Boolean }) visible!: boolean;
    @Prop({ type: String }) footerDisplay!: string;
    @Prop() message!: string;
    @Prop() htmlMessage!: string;
    @Prop() title!: string;

    innerTitle: string;
    innerMessage: string;
    innerHtmlMessage: string;

    @Watch("visible")
    visibleChanged(): void {
        this.$nextTick(function () {
            $('input, :input').attr('autocomplete', 'off');
        })
    }

    constructor() {
        super();
        this.innerTitle = "";
        this.innerMessage = "";
        this.innerHtmlMessage = "";
    }

    created(): void {
        this.innerTitle = this.title;
        this.innerMessage = this.message;
        this.innerHtmlMessage = this.htmlMessage;

        if (this.bus && this.namespace) {
            this.bus.$on(this.namespace + "/setData", this.setData);
        }
    };

    closeClick(): void {
        const self = this;
        const selfBase = self as any;
        //notify that modal wants to be closed
        //prop.visible should be changed in the parent to actually close the modal
        if (this.bus && this.namespace) {
            this.bus.$emit(this.namespace + "/close");
        }
        selfBase.$emit("close");
    };

    setData(title: string, msg: string, html: string): void {
        this.innerTitle = title;
        this.innerMessage = msg;
        this.innerHtmlMessage = html;
    };
    
    @Watch('title')
    onTitleChange(value: any, oldValue: any) {
        this.innerTitle = value;
    }
}
